export default __webpack_public_path__ + "static/media/OPManagement.b8aa861d.svg";